module.exports = __webpack_public_path__ + "img/navigation.0368b800.svg";